import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/start-stop-switch/start-stop-switch.js';
      import {ObcStartStopSwitchChangeEvent, StartStopSwitchVariant, StartStopSwitchSize} from '@oicl/openbridge-webcomponents/dist/components/start-stop-switch/start-stop-switch.js';

      export interface Props {
     checked?: boolean;
     showUncheckedStateIcon?: boolean;
     variant?: StartStopSwitchVariant;
     showCheckedStateIcon?: boolean;
     size?: StartStopSwitchSize;
     disabled?: boolean;
     hasAlert?: boolean;
     hasDescription?: boolean;
     description?: string
   }

      
  
      export type {ObcStartStopSwitchChangeEvent, StartStopSwitchVariant, StartStopSwitchSize} from '@oicl/openbridge-webcomponents/dist/components/start-stop-switch/start-stop-switch.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcStartStopSwitch',
  props: {
    checked: { type: Boolean },
    showUncheckedStateIcon: { type: Boolean },
    variant: {},
    showCheckedStateIcon: { type: Boolean },
    size: {},
    disabled: { type: Boolean },
    hasAlert: { type: Boolean },
    hasDescription: { type: Boolean },
    description: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onChange: (event: ObcStartStopSwitchChangeEvent) => emit('change', event as ObcStartStopSwitchChangeEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-start-stop-switch',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})